import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const searchVehicleModification = async (request) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicle-modification/search`,
      request,
    );
    return response.data;
  } catch (error) {
    console.log("error get results", error);
    throw error;
  }
};

export const updateVehicleCheckup = async (request, currentUser, companyId) => {
  try {
    const response = await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicle-modification/update?currentUser=${currentUser}&companyId=${companyId}`,
      request,
    );
    return response.data;
  } catch (error) {
    console.log("error updating vehicle checkup", error);
    throw error;
  }
};